var map = {
	"./arrow_home_consulta.svg": "39b2",
	"./arrow_pre.svg": "4c43",
	"./empty-cart.svg": "690d",
	"./envelope_icon.svg": "5849",
	"./envelope_icon_white.svg": "b110",
	"./logo-resolve.svg": "7bbf",
	"./lupa_azul.svg": "4cf0",
	"./lupa_branca.svg": "2873",
	"./lupa_vazia_1.svg": "79d9",
	"./pasta_1.svg": "9c1b",
	"./sms_icon.svg": "30e2",
	"./vazio_2_azul.svg": "45cd",
	"./vazio_2_cinza.svg": "ee52",
	"./whatsapp_logo.svg": "cb03"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ceb7";